import React from "react";

import withStyles from "@material-ui/core/styles/withStyles";

import OSSIcon from "../OSSIcon/OSSIcon";

const styles = theme => ({
  container: {
    display: "flex",
    alignItems: "center",
    height: `100%`,
    width: "100%",
    justifyContent: "center"
  },
  spinner: {
    animation: "$rotation 5s infinite"
  },

  "@keyframes rotation": {
    from: {
      rotate: "0deg"
    },
    to: {
      rotate: "360deg"
    }
  },
  loader: {
    width: 250,
    height: 250,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 125,

    background: `linear-gradient(	  
        to right,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0.5) 50%,
        rgba(255, 255, 255, 0) 80%
      ),
      #dfdfdf`,
    border: "1px solid #cecece",
    backgroundRepeat: "repeat-y",
    backgroundSize: "50px 500px",
    backgroundPosition: "0 0",
    animation: "$shine 1s infinite"
  },

  "@keyframes shine": {
    to: {
      backgroundPosition: "100% 0, 0 0"
    }
  }
});

const OSSFullPageSpinner = ({ classes }) => {
  return (
    <div className={classes.container}>
      <div className={classes.loader}>
        <OSSIcon name="dvLogo" showWords={false} height="200px" width="200px" />
      </div>
    </div>
  );
};

export default withStyles(styles)(OSSFullPageSpinner);
